// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#home-app-bar .v-tabs-slider[data-v-2d29251b] {\n  max-width: 24px;\n  margin: 0 auto;\n}\n#home-app-bar[data-v-2d29251b]:before {\n  display: none;\n}\n.pointer[data-v-2d29251b] {\n  cursor: pointer;\n}\n.user-info[data-v-2d29251b] {\n  width: 250px;\n  margin-right: -15px;\n}\n.v-menu__content[data-v-2d29251b] {\n  z-index: 12 !important;\n}", ""]);
// Exports
module.exports = exports;
